// 售后相关订单的共用表格列定义
import {getWithholdChannelText, getWithholdChannelType, shouldShowWithholdChannel} from "@/enum/dict/withholdChannel";

export function getAfterSaleOrderColumns(
  operationColumn,
  { showJointOrderTag = false } = {},
) {
  const baseColumns = [
    {
      label: "客户信息",
      prop: "member",
      minWidth: "180",
      customRender(h, row) {
        return (
          <div>
            <div>姓名：{row["memberName"] || ""}</div>
            <div>手机号：{row["memberMobile"] || ""}</div>
          </div>
        );
      },
    },
    {
      label: "客服",
      prop: "kfUserName",
      minWidth: "100",
      customRender(h, row) {
        return <p>{row["kfUserName"] || ""}</p>;
      },
    },
    {
      label: "催收",
      prop: "dcUserName",
      minWidth: "100",
      customRender(h, row) {
        return <p>{row["dcUserName"] || ""}</p>;
      },
    },
    {
      label: "售后信息",
      prop: "afterSale",
      minWidth: "240",
      customRender(h, row) {
        return (
          <div>
            <div>售后状态：{row["order"]?.["afterSaleStatusName"] || ""}</div>
            <div>流转时间：{row["flowTime"] || ""}</div>
            <div>已流转：{row["flowDayNum"] || 0}天</div>
          </div>
        );
      },
    },
    {
      label: "跟进记录",
      prop: "followContent",
      minWidth: "240",
      customRender(h, row) {
        return (
          <div>
            <el-tooltip content={row["followContent"] || ""} placement="top">
              <div style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis;">
                {row["followContent"] || ""}
              </div>
            </el-tooltip>
            <div style="color: #909399; font-size: 12px; margin-top: 5px">
              {row["followTime"] || ""}
            </div>
          </div>
        );
      },
    },
    {
      label: "下次跟进日期",
      prop: "nextFollowDate",
      minWidth: "150",
      customRender(h, row) {
        return <p>{row["nextFollowDate"] || ""}</p>;
      },
    },
    {
      label: "订单逾期天数",
      prop: "overdueDayNum",
      minWidth: "120",
      customRender(h, row) {
        return <p>{row["overdueDayNum"] || 0}</p>;
      },
    },
    {
      label: "商品信息",
      prop: "goods",
      minWidth: "250",
      customRender(h, row) {
        return (
          <div>
            <div>商品名称：{row["order"]?.["goodsTitle"] || ""}</div>
            <div>设备状态：{row["order"]?.["deviceStatusName"] || ""}</div>
            <div>
              锁机状态：
              <el-tag
                v-show={row["order"]["lockStatus"] == 0}
                type="success"
                size="mini"
              >
                未锁机
              </el-tag>
              <el-tag
                v-show={row["order"]["lockStatus"] == 1}
                type="warning"
                size="mini"
              >
                待锁机
              </el-tag>
              <el-tag
                v-show={row["order"]["lockStatus"] == 2}
                type="danger"
                size="mini"
              >
                已锁机
              </el-tag>
            </div>
          </div>
        );
      },
    },
    {
      label: "订单信息",
      prop: "order",
      minWidth: "260",
      customRender(h, row) {
        return (
          <div>
            <div>订单号：{row["orderNo"] || ""}</div>
            <div>下单时间：{row["order"]?.["createTime"] || ""}</div>
            <div>订单状态：{row["order"]?.["statusName"] || ""}</div>
            <div>
              订单标签：
              <el-tag type={row["isForceApprove"] ? "success" : "info"} size="mini">
                {row["isForceApprove"] ? "特批" : "非特批"}
              </el-tag>
              {showJointOrderTag && (
                <el-tag
                  type={row["isJointOrder"] ? "success" : "info"}
                  size="mini"
                  style="margin-left: 5px"
                >
                  {row["isJointOrder"] ? "联营" : "非联营"}
                </el-tag>
              )}
              <el-tag
                  v-show={shouldShowWithholdChannel(row["order"]?.["withholdChannel"])}
                  type={getWithholdChannelType(row["order"]?.["withholdChannel"])}
                  size="mini"
                  style="margin-left: 5px"
              >
                {getWithholdChannelText(row["order"]?.["withholdChannel"])}
              </el-tag>
            </div>
            <div>机构资方：{row["capitalOrgName"] || "-"}</div>
          </div>
        );
      },
    },
    {
      label: "门店信息",
      prop: "store",
      minWidth: "200",
      customRender(h, row) {
        return (
          <div>
            <div>门店名称：{row["storeName"] || ""}</div>
            <div>区域负责人：{row["areaFollowUserName"] || ""}</div>
          </div>
        );
      },
    },
    {
      label: "审核",
      prop: "reviewUserName",
      minWidth: "100",
      customRender(h, row) {
        return <p>{row["reviewUserName"] || ""}</p>;
      },
    },
  ];

  // 如果提供了操作列，则添加
  if (operationColumn) {
    baseColumns.push(operationColumn);
  }

  return baseColumns;
}
